import * as React from 'react';

import { numbersSwedish } from '../constants/numbersSwedish';
import { SignatoryOption } from '../types';
import { Flex, VerticalSpacer } from '../../Layout';
import { Text } from '../../Text';
import { Headings } from '../../Headings';
import { Checkbox, RadioButton } from '../../Form';

type AlternativeProps = {
  amountSignatoriesRequired: number;
  signatoryList: SignatoryOption[];
  number: number;
  isOnlyAlternative: boolean;
  selectedOptions: number[];
  selectOption: (index: number) => void;
};

export const Alternative = ({
  amountSignatoriesRequired,
  number,
  signatoryList,
  isOnlyAlternative = false,
  selectedOptions,
  selectOption,
}: AlternativeProps) => {
  const amountSignatoriesRequiredText = `${numbersSwedish[amountSignatoriesRequired]} ${
    amountSignatoriesRequired > 1 ? 'signaturer' : 'signatur'
  } krävs`;
  return (
    <Flex flexDirection="column">
      {isOnlyAlternative ? (
        <Headings.H4 marginBottom="1.25rem">{amountSignatoriesRequiredText}</Headings.H4>
      ) : (
        <>
          <Headings.H4>Alternativ {number}</Headings.H4>
          <Text marginBottom="1.25rem" fontWeight="normal" size="medium">
            {amountSignatoriesRequiredText}
          </Text>
        </>
      )}

      {signatoryList.map((signatory, signatoryIndex) => (
        <React.Fragment key={`${signatoryIndex}${number}`}>
          {amountSignatoriesRequired === 1 ? (
            <RadioButton
              id={`radio-button-alternative-${number}-signatory-${signatoryIndex}`}
              value=""
              label={fullName(signatory)}
              name="signatory-name"
              checked={selectedOptions.includes(signatoryIndex)}
              onChange={() => selectOption(signatoryIndex)}
              disabled={!signatory.isValid}
            />
          ) : (
            <Checkbox
              id={`checkbox-alternative-${number}-signatory-${signatoryIndex}`}
              size="small"
              checked={selectedOptions.includes(signatoryIndex)}
              onChange={() => selectOption(signatoryIndex)}
              disabled={!signatory.isValid}
            >
              <Text size="medium">{fullName(signatory)}</Text>
            </Checkbox>
          )}
          <VerticalSpacer marginBottom={['1.25rem', '1.25rem', '0.625rem']} />
        </React.Fragment>
      ))}
    </Flex>
  );
};

const fullName = (signatory: SignatoryOption) => {
  return `${signatory.firstName} ${signatory.lastName} ${signatory.isRequester ? '(jag)' : ''}`;
};
